module.exports = __webpack_public_path__ + "static/media/profile.e02c7f8d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GlobalNav/assets/profile.svg
// module id = 1927
// module chunks = 0